import vatService from 'js/vue/api/taxes/vatService.js';

export default {
    namespaced: true,
    state() {
        return {
            taxes: [],
            listNoEcoTaxes: [],
            listEcoTaxes: [],
            selectedVat: 0,
            taxesSettings: null,
        };
    },
    getters: {
        taxes: (state) => state.taxes,
        selectedVat: (state) => state.selectedVat,
        listEcoTaxes: (state) => state.listEcoTaxes,
        listNoEcoTaxes: (state) => state.listNoEcoTaxes,
        taxesSettings: (state) => state.taxesSettings,
        defaultRateCategory: (state) => state.taxesSettings.rate_category_id,
    },
    mutations: {
        setTaxes(state, payload) {
            state.taxes = payload;
        },
        setVatSelected(state, payload) {
            state.vatSelected = payload;
        },
        setListEcoTaxes(state, payload) {
            state.listEcoTaxes = payload;
        },
        setListNoEcoTaxes(state, payload) {
            state.listNoEcoTaxes = payload;
        },
        setSettingsTaxes(state, payload) {
            state.taxesSettings = payload;
        },
    },
    actions: {
        fetchTaxesSettings({ commit }) {
            return new Promise((resolve) => {
                vatService.getTaxesSettings().then((response) => {
                    commit('setSettingsTaxes', response.data);
                    resolve();
                });
            });
        },
        fetchTaxes({ commit }) {
            return new Promise((resolve) => {
                vatService.getAllTaxes().then((response) => {
                    for (const taxeIndex in response) {
                        response[taxeIndex].translations = response[taxeIndex]._embed?.translations;
                    }
                    commit('setTaxes', response);
                    commit('setListNoEcoTaxes', [...response.filter((tax) => !tax.is_ecotax)]);
                    commit('setListEcoTaxes', [...response.filter((tax) => tax.is_ecotax)]);
                    commit('setVatSelected', response[0].id);
                    resolve();
                });
            });
        },
        updateTaxes({ dispatch }, taxes) {
            return new Promise((resolve, reject) => {
                vatService
                    .updateTaxes(taxes)
                    .then(() => {
                        dispatch('fetchTaxes').then(() => {
                            resolve();
                        });
                    })
                    .catch((err) => reject(err));
            });
        },
        updateEcoTaxes({ commit }, ecoTaxes) {
            return new Promise((resolve, reject) => {
                vatService
                    .updateEcoTaxes(ecoTaxes)
                    .then(() => {
                        commit('setListEcoTaxes', ecoTaxes);
                        resolve();
                    })
                    .catch((err) => reject(err));
            });
        },
        updateTaxesSettings({ getters }, signal = undefined) {
            return new Promise((resolve, reject) => {
                vatService
                    .updateTaxesSettings(getters.taxesSettings, signal)
                    .then(() => {
                        resolve();
                    })
                    .catch((error) => {
                        if (error.name === 'AbortError') {
                            // Request was aborted, do not treat as an error
                            return;
                        }
                        reject(error);
                    });
            });
        },
    },
};
